import { useFormContext } from 'react-hook-form';

import { StrategyFormData } from '../../../../../../providers/backtesting/types';
import { CollapsibleSection } from '../../components/collapsible-section';
import { BacktestingInput } from '../../components/backtesting-input';
import { BacktestingSelect } from '../../components/backtesting-select';
import { FormRow } from '../../components/form-row';

const ROLL_CONDITION_OPTIONS = [
  { name: 'Short options delta', value: 'short_options_delta' },
  { name: 'Time to expiry', value: 'time_to_expiry' },
  { name: 'Spot move since inception', value: 'spot_move_since_inception' },
  { name: 'Absolute spot move since inception', value: 'absolute_spot_move_since_inception' },
];

const COMPARISON_OPTIONS = [
  { name: 'Equal to', value: 'eq' },
  { name: 'Not equal to', value: 'neq' },
  { name: 'Greater than', value: 'gt' },
  { name: 'Greater than or equal to', value: 'gte' },
  { name: 'Less than', value: 'lt' },
  { name: 'Less than or equal to', value: 'lte' },
];

const rollConditionTooltip = (
  <div>
    <p>
      <strong> Short options delta:</strong> the aggregate delta of all short option positions in
      the portfolio package.
      <br />
      <br />
      <strong> Time to expiry:</strong> the time remaining until expiry of the first option in the
      portfolio package.
      <br />
      <br />
      <strong> Spot move since inception:</strong> the directional change in spot since inception
      (e.g., spot(t) &gt; spot(0) + 1000 or spot(t) &lt; spot(0) - 2000).
      <br />
      <br />
      <strong> Absolute spot move since inception:</strong> the absolute change in spot since
      inception (e.g., |spot(t) - spot(0)| &gt; 1000).
    </p>
  </div>
);

export const RollPositionsSection = () => {
  const { register, watch, setValue } = useFormContext<StrategyFormData>();

  const selectedRollCondition =
    ROLL_CONDITION_OPTIONS.find((o) => o.value === watch('rollPositions.rollCondition')) ??
    ROLL_CONDITION_OPTIONS[0];

  const selectedComparison =
    COMPARISON_OPTIONS.find((o) => o.value === watch('rollPositions.comparison')) ??
    COMPARISON_OPTIONS[0];

  return (
    <CollapsibleSection title="Roll Positions" defaultOpen={false}>
      <FormRow columns={4}>
        <div className="field-group">
          <BacktestingSelect
            size="fluid"
            label="Roll Condition"
            tooltip={rollConditionTooltip}
            values={ROLL_CONDITION_OPTIONS}
            defaultValue={selectedRollCondition}
            onChange={(value) =>
              setValue('rollPositions.rollCondition', value, { shouldDirty: true })
            }
          />
        </div>

        <div className="field-group">
          <label className="field-label">Comparison</label>
          <BacktestingSelect
            size="fluid"
            values={COMPARISON_OPTIONS}
            defaultValue={selectedComparison}
            onChange={(value) => setValue('rollPositions.comparison', value, { shouldDirty: true })}
          />
        </div>

        <div className="field-group">
          <BacktestingInput
            size="fluid"
            label="Value"
            placeholder="Value"
            {...register('rollPositions.value')}
          />
        </div>

        <div className="field-group">
          <BacktestingInput
            size="fluid"
            label="Roll Type"
            tooltip={`The selected roll type will close the existing trade and reopen the original position.`}
            placeholder="Roll Type"
            {...register('rollPositions.rollType')}
          />
        </div>
      </FormRow>
    </CollapsibleSection>
  );
};
